import { GitFetchGitError } from '../errors/git-fetch.git-error';
import { setToken } from '../util/set-token';
import { WorkerAction, WorkerFnParams } from '../wasm-git.worker.model';
import type { GitAction } from './actions.enum';

export interface GitFetchAction extends WorkerAction {
  type: GitAction.Fetch;
  params: { authToken: string; fastForwardingBranches?: string[]; prune?: boolean };
}

export async function GitFetchActionFn({ lg, util, params }: WorkerFnParams<GitFetchAction>): Promise<void> {
  try {
    setToken(params.authToken);

    if (params.fastForwardingBranches) {
      lg.callAndCaptureOutput(['fetch', '.', ...params.fastForwardingBranches]);
    } else {
      lg.callAndCaptureOutput(['fetch', 'origin', ...(params.prune ? ['--prune'] : [])]);
    }
  } catch (err) {
    console.error(`[WasmGit]: git fetch failed`, err);
    throw new GitFetchGitError();
  } finally {
    await util.syncfs(false);
  }
}
